import React, { useState, useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import * as api from "../api";

function RFQ() {
  const { user } = useAuth();
  const [searchParams] = useSearchParams();

  // ✅ Récupère annonceId et annonceNom depuis l'URL si venu d'une annonce
  const annonceIdFromUrl = searchParams.get("annonceId") || "";
  const annonceNomFromUrl = searchParams.get("annonceNom") || "";

  const [step, setStep] = useState(1);
  const [submitted, setSubmitted] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [formData, setFormData] = useState({
    besoin: "",
    projet: "",
    nom: user ? `${user.prenom} ${user.nom}` : "",
    email: user?.email || "",
    telephone: user?.telephone || "",
    typeProduit: "",
    quantite: "",
    dateLimite: "",
    details: "",
    annonceId: annonceIdFromUrl,
    annonceNom: annonceNomFromUrl,
  });

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.createRFQ({
        ...formData,
        email: user ? user.email : formData.email,
        nom: formData.nom,
        annonceId: formData.annonceId || null,
      });
      setSubmitted(true);
    } catch (err) {
      console.error(err);
    }
  };

  if (submitted) {
    return (
      <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
        <Navbar />
        <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: "#f9fafb" }}>
          <div style={{ textAlign: "center", padding: "60px", backgroundColor: "white", borderRadius: "20px", boxShadow: "0 4px 20px rgba(0,0,0,0.1)", maxWidth: "480px", width: "100%", margin: "20px" }}>
            <div style={{ width: "80px", height: "80px", borderRadius: "50%", backgroundColor: "#f0fdfa", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 20px" }}>
              <svg width="40" height="40" viewBox="0 0 24 24" fill="#0d9488"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>
            </div>
            <h2 style={{ fontSize: "24px", fontWeight: "700", color: "#1f2937", marginBottom: "12px" }}>Demande envoyée ! 🎉</h2>
            <p style={{ color: "#6b7280", fontSize: "15px", lineHeight: "1.6", marginBottom: "30px" }}>
              Votre demande a été enregistrée. Vous recevrez des offres dans les 48 heures.
            </p>
            <div style={{ display: "flex", gap: "12px", justifyContent: "center", flexWrap: "wrap" }}>
              {user && (
                <Link to="/mon-espace" style={{ display: "inline-flex", alignItems: "center", gap: "8px", backgroundColor: "#0d9488", color: "white", padding: "12px 24px", borderRadius: "10px", textDecoration: "none", fontSize: "14px", fontWeight: "600" }}>
                  Voir mes demandes
                </Link>
              )}
              <Link to="/catalogue" style={{ display: "inline-flex", alignItems: "center", gap: "8px", backgroundColor: "white", color: "#374151", padding: "12px 24px", borderRadius: "10px", textDecoration: "none", fontSize: "14px", fontWeight: "600", border: "1px solid #e5e7eb" }}>
                Retour au catalogue
              </Link>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }

  const inputStyle = { width: "100%", padding: "12px 15px", border: "1px solid #e5e7eb", borderRadius: "8px", fontSize: "14px", outline: "none", backgroundColor: "white", boxSizing: "border-box" };
  const labelStyle = { display: "block", fontSize: "14px", fontWeight: "500", color: "#374151", marginBottom: "8px" };

  return (
    <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <Navbar />
      <div style={{ flex: 1, backgroundColor: "#f9fafb", padding: "60px 20px" }}>
        <div style={{ maxWidth: "1000px", margin: "0 auto" }}>
          <div style={{ textAlign: "center", marginBottom: "50px" }}>
            <h1 style={{ fontSize: isMobile ? "24px" : "36px", fontWeight: "700", color: "#1f2937", marginBottom: "15px" }}>Demande de devis personnalisé</h1>
            <p style={{ fontSize: "18px", color: "#6b7280", maxWidth: "700px", margin: "0 auto", lineHeight: "1.6" }}>
              Bénéficiez de notre réseau de fournisseurs pour concrétiser vos projets d'achat.
            </p>
          </div>

          {/* Annonce liée */}
          {formData.annonceNom && (
            <div style={{ backgroundColor: "#f0fdfa", border: "1px solid #0d9488", borderRadius: "12px", padding: "14px 20px", marginBottom: "30px", display: "flex", alignItems: "center", gap: "12px" }}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#0d9488" strokeWidth="2">
                <path d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"/>
              </svg>
              <div>
                <p style={{ fontSize: "12px", color: "#6b7280", marginBottom: "2px" }}>Demande liée à l'annonce</p>
                <p style={{ fontSize: "14px", fontWeight: "700", color: "#0d9488" }}>{formData.annonceNom}</p>
              </div>
            </div>
          )}

          {/* Steps */}
          <div style={{ display: "flex", justifyContent: "center", alignItems: "flex-start", marginBottom: "50px" }}>
            {[1, 2, 3].map((num) => (
              <div key={num} style={{ display: "flex", alignItems: "center" }}>
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "6px" }}>
                  <div style={{ width: "40px", height: "40px", borderRadius: "50%", backgroundColor: step >= num ? "#0d9488" : "#e5e7eb", color: step >= num ? "white" : "#9ca3af", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: "600", fontSize: "16px", flexShrink: 0 }}>
                    {step > num ? <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg> : num}
                  </div>
                  <div style={{ fontSize: isMobile ? "11px" : "13px", fontWeight: "600", color: step >= num ? "#1f2937" : "#9ca3af", textAlign: "center", maxWidth: isMobile ? "60px" : "80px" }}>
                    {num === 1 ? "Votre besoin" : num === 2 ? "Votre projet" : "Coordonnées"}
                  </div>
                </div>
                {num < 3 && <div style={{ width: isMobile ? "30px" : "60px", height: "2px", backgroundColor: step > num ? "#0d9488" : "#e5e7eb", margin: isMobile ? "0 6px" : "0 12px", marginBottom: "22px", flexShrink: 0 }}></div>}
              </div>
            ))}
          </div>

          {/* Comment ça marche */}
          <div style={{ backgroundColor: "white", borderRadius: "12px", padding: "30px", marginBottom: "40px", boxShadow: "0 1px 3px rgba(0,0,0,0.1)" }}>
            <h3 style={{ fontSize: "18px", fontWeight: "600", color: "#1f2937", marginBottom: "20px" }}>Comment ça marche ?</h3>
            <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "repeat(3, 1fr)", gap: "30px" }}>
              {[
                { icon: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z", title: "Décrivez votre projet", desc: "Remplissez notre formulaire avec les détails de votre besoin." },
                { icon: "M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z", title: "Nous sélectionnons", desc: "Nous trouvons les meilleurs fournisseurs pour votre projet." },
                { icon: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2", title: "Comparez les devis", desc: "Recevez et comparez les offres pour faire le meilleur choix." }
              ].map((item, i) => (
                <div key={i} style={{ display: "flex", flexDirection: isMobile ? "row" : "column", alignItems: "center", gap: isMobile ? "16px" : "0", textAlign: isMobile ? "left" : "center" }}>
                  <div style={{ width: "60px", height: "60px", backgroundColor: "#f0fdfa", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", margin: isMobile ? "0" : "0 auto 15px", flexShrink: 0 }}>
                    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#0d9488" strokeWidth="2"><path d={item.icon}/></svg>
                  </div>
                  <div>
                    <h4 style={{ fontSize: "16px", fontWeight: "600", color: "#1f2937", marginBottom: "8px" }}>{item.title}</h4>
                    <p style={{ fontSize: "14px", color: "#6b7280", lineHeight: "1.5" }}>{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <form onSubmit={handleSubmit}>
            <div style={{ backgroundColor: "white", borderRadius: "12px", padding: isMobile ? "24px 16px" : "40px", boxShadow: "0 1px 3px rgba(0,0,0,0.1)" }}>

              {step === 1 && (
                <div>
                  <h2 style={{ fontSize: "20px", fontWeight: "600", color: "#1f2937", marginBottom: "25px", paddingBottom: "15px", borderBottom: "1px solid #e5e7eb" }}>Votre besoin</h2>
                  <div style={{ marginBottom: "25px" }}>
                    <label style={labelStyle}>Type de produit *</label>
                    <select name="typeProduit" value={formData.typeProduit} onChange={handleChange} required style={inputStyle}>
                      <option value="">Sélectionnez un type...</option>
                      <option value="yacht">Yacht / Bateau de luxe</option>
                      <option value="bateau_moteur">Bateau à moteur</option>
                      <option value="voilier">Voilier</option>
                      <option value="equipement">Équipement nautique</option>
                      <option value="moteur">Moteur marin</option>
                      <option value="electronique">Électronique marine</option>
                      <option value="sport">Sports nautiques</option>
                      <option value="autre">Autre</option>
                    </select>
                  </div>
                  <div style={{ marginBottom: "25px" }}>
                    <label style={labelStyle}>Décrivez votre besoin *</label>
                    <textarea name="besoin" value={formData.besoin} onChange={handleChange} placeholder="Décrivez en détail le produit que vous recherchez..." required rows="4" style={{ ...inputStyle, resize: "vertical" }}></textarea>
                  </div>
                  <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr", gap: "20px" }}>
                    <div>
                      <label style={labelStyle}>Quantité estimée</label>
                      <input type="number" name="quantite" value={formData.quantite} onChange={handleChange} placeholder="Ex: 1, 10..." min="1" style={inputStyle} />
                    </div>
                    <div>
                      <label style={labelStyle}>Date limite souhaitée</label>
                      <input type="date" name="dateLimite" value={formData.dateLimite} onChange={handleChange} style={inputStyle} />
                    </div>
                  </div>
                </div>
              )}

              {step === 2 && (
                <div>
                  <h2 style={{ fontSize: "20px", fontWeight: "600", color: "#1f2937", marginBottom: "25px", paddingBottom: "15px", borderBottom: "1px solid #e5e7eb" }}>Votre projet</h2>
                  <div style={{ marginBottom: "25px" }}>
                    <label style={labelStyle}>Décrivez votre projet *</label>
                    <textarea name="projet" value={formData.projet} onChange={handleChange} placeholder="Décrivez votre projet, l'utilisation prévue, les spécifications techniques..." required rows="6" style={{ ...inputStyle, resize: "vertical" }}></textarea>
                  </div>
                  <div>
                    <label style={labelStyle}>Détails supplémentaires</label>
                    <textarea name="details" value={formData.details} onChange={handleChange} placeholder="Budget approximatif, préférences de marque, exigences particulières..." rows="4" style={{ ...inputStyle, resize: "vertical" }}></textarea>
                  </div>
                </div>
              )}

              {step === 3 && (
                <div>
                  <h2 style={{ fontSize: "20px", fontWeight: "600", color: "#1f2937", marginBottom: "25px", paddingBottom: "15px", borderBottom: "1px solid #e5e7eb" }}>Vos coordonnées</h2>
                  <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr", gap: "20px", marginBottom: "25px" }}>
                    <div>
                      <label style={labelStyle}>Nom complet *</label>
                      <input type="text" name="nom" value={formData.nom} onChange={handleChange} placeholder="Votre nom et prénom" required style={inputStyle} />
                    </div>
                    <div>
                      <label style={labelStyle}>Email *</label>
                      <input type="email" name="email" value={formData.email} onChange={handleChange} placeholder="votre@email.com" required readOnly={!!user}
                        style={{ ...inputStyle, backgroundColor: user ? "#f9fafb" : "white", color: user ? "#6b7280" : "#1f2937" }} />
                      {user && <p style={{ fontSize: "12px", color: "#9ca3af", marginTop: "4px" }}>Email lié à votre compte</p>}
                    </div>
                  </div>
                  <div style={{ marginBottom: "25px" }}>
                    <label style={labelStyle}>Numéro de téléphone *</label>
                    <input type="tel" name="telephone" value={formData.telephone} onChange={handleChange} placeholder="+213 5XX XXX XXX" required style={inputStyle} />
                  </div>
                  <div style={{ backgroundColor: "#f0fdfa", padding: "20px", borderRadius: "8px" }}>
                    <p style={{ fontSize: "14px", color: "#065f46", lineHeight: "1.6" }}>
                      <strong>Important :</strong> Vous recevrez les devis sous 48H. Service gratuit et sans engagement.
                    </p>
                  </div>
                </div>
              )}

              <div style={{ display: "flex", justifyContent: "space-between", marginTop: "40px", paddingTop: "25px", borderTop: "1px solid #e5e7eb" }}>
                {step > 1 ? (
                  <button type="button" onClick={() => setStep(step - 1)} style={{ padding: "12px 30px", backgroundColor: "white", color: "#374151", border: "1px solid #e5e7eb", borderRadius: "8px", fontSize: "15px", fontWeight: "600", cursor: "pointer" }}>← Retour</button>
                ) : <div />}
                {step < 3 ? (
                  <button type="button" onClick={() => setStep(step + 1)} style={{ padding: "12px 30px", backgroundColor: "#0d9488", color: "white", border: "none", borderRadius: "8px", fontSize: "15px", fontWeight: "600", cursor: "pointer" }}>Continuer →</button>
                ) : (
                  <button type="submit" style={{ padding: "12px 30px", backgroundColor: "#0d9488", color: "white", border: "none", borderRadius: "8px", fontSize: "15px", fontWeight: "600", cursor: "pointer" }}>Soumettre la demande</button>
                )}
              </div>
            </div>
          </form>

          <div style={{ marginTop: "30px", textAlign: "center", color: "#6b7280", fontSize: "14px" }}>
            <p>Vous recevrez les devis dans les 48 heures. Service gratuit et sans engagement.</p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default RFQ;